import React from 'react'

export const ALL_NON_COMPLIANT_DICOM = 'ALL_NON_COMPLIANT_DICOM'